module.exports = __webpack_public_path__ + "static/media/36.d708bf8b.png";